import React from 'react';
import { IconSvgProps } from '@models/common';

const NavDetector: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.9504 9.99961C15.9502 6.7137 13.2856 4.05 9.99961 4.05C6.71382 4.05021 4.05021 6.71382 4.05 9.99961C4.05 13.2856 6.7137 15.9502 9.99961 15.9504C13.2857 15.9504 15.9504 13.2857 15.9504 9.99961ZM18.0504 9.99961C18.0504 11.8437 17.4281 13.5419 16.3852 14.8992L21.743 20.257C22.153 20.6671 22.153 21.3329 21.743 21.743C21.3329 22.153 20.6671 22.153 20.257 21.743L14.8992 16.3852C13.5419 17.4281 11.8437 18.0504 9.99961 18.0504C5.5539 18.0502 1.95 14.4454 1.95 9.99961C1.95021 5.55403 5.55403 1.95021 9.99961 1.95C14.4454 1.95 18.0502 5.5539 18.0504 9.99961Z'
        fill='currentColor'
      />
      <path
        d='M9.78942 6.1876C9.882 5.93747 10.2362 5.93747 10.3288 6.1876L11.2557 8.69263C11.27 8.7315 11.2926 8.76681 11.3219 8.79614C11.3512 8.82547 11.3865 8.84812 11.4253 8.86254L13.9306 9.78946C14.1807 9.88203 14.1807 10.2362 13.9306 10.3288L11.4256 11.2557C11.3867 11.2701 11.3514 11.2927 11.3221 11.322C11.2928 11.3512 11.2701 11.3865 11.2557 11.4254L10.3288 13.9304C10.2362 14.1808 9.882 14.1808 9.78942 13.9304L8.86252 11.4256C8.84816 11.3868 8.82557 11.3515 8.79629 11.3221C8.76701 11.2928 8.73174 11.2702 8.69289 11.2557L6.1876 10.3288C5.93747 10.2362 5.93747 9.88203 6.1876 9.78946L8.6926 8.86254C8.73148 8.84818 8.76678 8.82559 8.79611 8.79631C8.82544 8.76704 8.84809 8.73176 8.86252 8.69291L9.78942 6.1876Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default NavDetector;
